import { config } from "@/config";
import axios from "axios";
import { handleAxiosError } from "./utils";

const PUBLIC_VALIDATE_BETA_INVITE_PATH =
  "/api/v2/public/beta-invite-codes/validate";

const publicInviteAxios = axios.create({
  baseURL: config.hosts.api,
});

publicInviteAxios.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(handleAxiosError(error)),
);

export interface ValidateBetaInviteCodeResult {
  valid: boolean;
  trial_days: number;
  payment_method_required: boolean;
}

export async function validateBetaInviteCodePublic(
  inviteCode: string,
): Promise<ValidateBetaInviteCodeResult> {
  const response = await publicInviteAxios.post<{
    data: ValidateBetaInviteCodeResult;
  }>(PUBLIC_VALIDATE_BETA_INVITE_PATH, {
    invite_code: inviteCode,
  });
  return response.data.data;
}
